import { useEffect, useContext } from 'react';

import { ViewportContext } from '../contexts/viewport';
import { DataLayerContext } from '../contexts/dataLayer';
import { useLanguage } from './useLanguage';
import {
  PAGE_VIEW,
  GA,
  EMAIL_PREFERENCES_PAGE_TITLE,
  EMAIL_PREFERENCES_CATEGORY,
  AUTHORS_PAGE_TITLE,
  AUTHORS_CATEGORY,
  ARTICLES_PAGE_TITLE,
  ARTICLES_CATEGORY,
  BLOG_CATEGORY,
  UNDEFINED
} from '../utils/variables';

export const useDataLayer = (data) => {
  const { setEventSorting, eventsorting } = useContext(DataLayerContext);
  const { device } = useContext(ViewportContext);
  const { langKey } = useLanguage();
  const isArticle = () => data?.content?.author;
  const isAuthor = () => data?.authors;
  const isPreferencePage = () => data?.content?.name === 'preferences';

  const pushEvent = (name, event) => {
    window.dataLayer.push({
      event: name,
      ...event,
      session: {
        experiment: 'control',
        eventsorting,
        sector: UNDEFINED,
        source: UNDEFINED,
        path: UNDEFINED
      }
    });
    setEventSorting(eventsorting + 1);
  };

  const pushPageViewEvent = (
    title,
    category,
    subcategory,
    languageSelected
  ) => {
    pushEvent(PAGE_VIEW, {
      page: {
        title,
        category,
        subcategory,
        referrer: document.referrer,
        languageSelected,
        platform: 'website'
      },
      user: {
        deviceType: device
      }
    });
  };

  const pushCustomEvent = (category, action, label = UNDEFINED) => {
    pushEvent(GA, {
      category,
      action,
      label
    });
  };

  const pushLanguageSelectedEvent = (languageSelected) => {
    pushEvent(PAGE_VIEW, {
      page: {
        languageSelected
      }
    });
  };

  useEffect(() => {
    if (data?.content?.dataLayer) {
      const { title, category, subCategory } = data.content.dataLayer;
      pushPageViewEvent(title, category, subCategory, langKey);
      // dataLayer for AUTHORS
    } else if (isAuthor()) {
      pushPageViewEvent(
        AUTHORS_PAGE_TITLE,
        BLOG_CATEGORY,
        AUTHORS_CATEGORY,
        langKey
      );
      // dataLayer for ARTICLES
    } else if (isArticle()) {
      pushPageViewEvent(
        ARTICLES_PAGE_TITLE,
        BLOG_CATEGORY,
        ARTICLES_CATEGORY,
        langKey
      );
      // dataLayer for Email Preferences page
    } else if (isPreferencePage()) {
      pushPageViewEvent(
        EMAIL_PREFERENCES_PAGE_TITLE,
        EMAIL_PREFERENCES_CATEGORY,
        EMAIL_PREFERENCES_CATEGORY,
        langKey
      );
    } else return;
  }, [data]);

  return {
    eventsorting,
    pushCustomEvent,
    pushLanguageSelectedEvent,
    pushCustomEvent
  };
};
